import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnValue,
  columnNameLink,
  columnTools,
  columnCategory,
  hasColumn,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import SystemFlag from '@/components/SystemFlag';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import { vocabularyGroupings } from '../constants';
import vocabularyComponents from '../helper';
import VocabularyTools from '../containers/VocabularyTools';
import events from '../hooks/events';

const VocabularyRow = ({
  category,
  className,
  columns = [columnNameLink, columnValue, columnTools, columnCategory],
  upward,
  vocabulary,
}) => {
  const { ValueCell } = vocabularyComponents[vocabulary.grouping];
  const show = events.useShowSaveVocabulary(category, vocabulary);

  return (
    <NameDescriptionRow
      asHref
      className={clsx('aridhia-vocabulary-row', className)}
      columns={columns}
      description={vocabulary.description}
      entity="vocabulary"
      href={codeUrl(urls.VOCABULARIES, vocabulary.code)}
      name={vocabulary.name}
      onClick={show}
      loading={vocabulary.updateStatus === states.PENDING}
    >
      {hasColumn(columns, columnCategory) && (
        <Table.Cell>
          <SystemFlag
            messageId={`vocabulary.grouping.${vocabulary.grouping}`}
            solid={[vocabularyGroupings.EMAIL_TEMPLATE].includes(vocabulary.grouping)}
            flush
          />
        </Table.Cell>
      )}
      {hasColumn(columns, columnValue) && (<ValueCell vocabulary={vocabulary} />)}
      {hasColumn(columns, columnTools) && (
        <Table.Cell collapsing>
          <VocabularyTools upward={upward} category={category} vocabulary={vocabulary} />
        </Table.Cell>
      )}
    </NameDescriptionRow>
  );
};

export default VocabularyRow;
